import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFamily } from '../services';

// Thunk asíncrono para obtener los datos de family desde la API
export const fetchFamilyData = createAsyncThunk(
    'family/fetchFamilyData',
    async (countryId = 1, { rejectWithValue }) => {
        try {
            const data = await fetchFamily(); // Llama al servicio de la API
            return data;
        } catch (error) {
            return rejectWithValue(error.message); // Manejo de errores
        }
    }
);

const familySlice = createSlice({
    name: 'family',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFamilyData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFamilyData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchFamilyData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default familySlice.reducer;
